// src/pages/Login.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import "../css/login.css";
import Swal from "sweetalert2";
import Logo from "../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const Login = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [branches, setBranches] = useState([]);
  const [branch, setBranch] = useState("");
  const [error, setError] = useState("");

  const [siteName, setSiteName] = useState("Infraconsoft");
  const [siteLogo, setSiteLogo] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      Swal.fire({
        title: "Loading",
        html: `
          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
          </div>
          <p style="margin-top: 10px; font-size: 14px;">Fetching branches & branding…</p>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const style = document.createElement("style");
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }`;
          document.head.appendChild(style);
        },
      });

      try {
        const [bRes, sRes] = await Promise.all([
          axios.get(`${API_BASE}/branches`),
          axios.get(`${API_BASE}/siteinfo`),
        ]);

        setBranches(bRes.data || []);

        const s = sRes.data || {};
        if (s.ok) {
          if (s.name) setSiteName(s.name);
          if (s.logo) {
            const url = /^https?:\/\//i.test(s.logo) ? s.logo : `${API_ORIGIN}${s.logo}`;
            setSiteLogo(url);
          }
        }
      } catch (err) {
        console.error("Init load error:", err);
        Swal.fire({ icon: "warning", title: "Some data failed to load", text: "Using defaults." });
      } finally {
        Swal.close();
      }
    };

    fetchData();
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!userName.trim())
      return Swal.fire({ icon: "warning", title: "Empty Field", text: "Please Enter Your Username!" });
    if (!password.trim())
      return Swal.fire({ icon: "warning", title: "Empty Field", text: "Please Enter Your Password!" });
    if (!branch.trim())
      return Swal.fire({ icon: "warning", title: "Empty Field", text: "Please Select your branch!" });

    try {
      const response = await axios.post(`${API_BASE}/login`, {
        username: userName,
        password,
        branch,
      });

      if (response.data.success) {
        const user = response.data.user || {};
        localStorage.setItem("username", userName);
        localStorage.setItem("branch", branch);
        localStorage.setItem("memberId", user.fld_memberId || "");
        localStorage.setItem("branch_code", user.fld_branch_code || "");
        localStorage.setItem("module", user.fld_dept || "");
        localStorage.setItem("company", siteName)
        navigate("/welcome");
      } else {
        Swal.fire({ icon: "error", title: "Invalid Username Or Password", text: "Please try again!" });
      }
    } catch (error) {
      setError("Error logging in");
      console.error("Login error:", error);
      Swal.fire({ icon: "error", title: "Login failed", text: "Please try again." });
    }
  };

  return (
    <div className="login">
      <div className="login_box">
        <div className="left">
          {/* <div className="top_link">
                <img src={Logo} alt='infra_logo' className="logo" />
          </div> */}

          <div className="contact">
            <form onSubmit={handleLogin}>
              <div className="margin-div">

                  <div className="product-brand">
          <img src={Logo} alt="App logo" className="product-logo" />
        </div>


                        <h3 className="hd">{siteName ? `${siteName} - Login` : "Login"}</h3>

                {error && <p style={{ color: "red" }}>{error}</p>}

                <input
                  type="text"
                  placeholder="USERNAME"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="PASSWORD"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <select value={branch} onChange={(e) => setBranch(e.target.value)}>
                  <option value="">Select Branch</option>
                  {branches.map((item) => (
                    <option key={item.branchMaster_Code} value={item.branchMaster_Code}>
                      {item.branchMaster_Name}
                    </option>
                  ))}
                </select>

                <button type="submit" className="submit">Login</button>
              </div>
            </form>
          </div>
        </div>

       
       
<div
  className={`right ${siteLogo ? "right-bg" : ""}`}
  style={siteLogo ? { backgroundImage: `url(${siteLogo})` } : undefined}
>
  {!siteLogo && (
    <div className="brand">
      <h2 className="brand-name">{siteName}</h2>
    </div>
  )}
</div>

      </div>
    </div>
  );
};

export default Login;
